import { IconDone } from 'icons/components/IconDone'
import { IconErrorL } from 'icons/components/IconErrorL'
import { usePathname, useSearchParams } from 'next/navigation'
import type { SnackbarProps } from 'notifications/components/Snackbar/Snackbar'
import {
	type Dispatch,
	type SetStateAction,
	useCallback,
	useEffect,
} from 'react'
import {
	getFromSessionStorage,
	removeFromSessionStorage,
	setToSessionStorage,
} from 'utils/webStorage/sessionStorage'

const SESSION_STORAGE_NOTIFICATION_KEY = 'notification-on-nav'

export enum SnackbarIcon {
	Done = 'done',
	Error = 'error',
}

const ICON_OPTIONS: Record<SnackbarIcon, SnackbarProps['icon']> = {
	[SnackbarIcon.Done]: <IconDone color='content-inverse' />,
	[SnackbarIcon.Error]: <IconErrorL color='content-inverse' />,
}

export type NavigationSnackbarProps = Omit<
	SnackbarProps,
	'onClick' | 'onClose' | 'icon'
> & { iconName?: SnackbarIcon }

export const useNotificationsStorage = (
	setActualNotification: Dispatch<SetStateAction<SnackbarProps[]>>
) => {
	const pathname = usePathname()
	const searchParams = useSearchParams()

	const addNotificationOnNavigation = useCallback(
		(item: NavigationSnackbarProps) => {
			setToSessionStorage(SESSION_STORAGE_NOTIFICATION_KEY, item)
		},
		[]
	)

	useEffect(() => {
		const notification = getFromSessionStorage<NavigationSnackbarProps>(
			SESSION_STORAGE_NOTIFICATION_KEY
		)
		if (notification) {
			const newNotification = {
				...notification,
				icon: notification.iconName
					? ICON_OPTIONS[notification.iconName]
					: undefined,
			}

			setActualNotification((prevQueue) => [...prevQueue, newNotification])
			removeFromSessionStorage(SESSION_STORAGE_NOTIFICATION_KEY)
		}
	}, [pathname, searchParams])

	return { addNotificationOnNavigation }
}
